import { Image } from 'antd';
import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        {
            title: 'Image', field: 'image_url', filterAndSearch: false, width: "150px",
            render: rowData => <div>
                <Image
                    width={50}
                    preview={false}
                    src={rowData.image_url} />
            </div>
        },
        { 
            title: 'Category', field: 'category_name', filterAndSearch: true
        },
        { 
            title: 'Category Status', field: 'status', filterAndSearch: false
        },
    ],
})

export default tableConfig;